import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiZap, FiShield, FiHeadphones, FiTrendingUp, FiDollarSign, FiRefreshCw } = FiIcons;

const Features = () => {
  const features = [
    {
      icon: FiZap,
      title: 'Instant Delivery',
      description: 'Most orders start within minutes. Fast and reliable service delivery.',
      color: 'from-yellow-500 to-orange-500'
    },
    {
      icon: FiShield,
      title: '100% Safe & Secure',
      description: 'SSL encrypted payments and secure processing. Your data is protected.',
      color: 'from-green-500 to-green-600'
    },
    {
      icon: FiHeadphones,
      title: '24/7 Support',
      description: 'Round-the-clock customer support via live chat, email, and phone.',
      color: 'from-blue-500 to-blue-600'
    },
    {
      icon: FiTrendingUp,
      title: 'High Quality',
      description: 'Premium quality services with real engagement from active users.',
      color: 'from-purple-500 to-purple-600'
    },
    {
      icon: FiDollarSign,
      title: 'Best Prices',
      description: 'Competitive pricing with bulk discounts. Best value for money.',
      color: 'from-green-500 to-teal-600'
    },
    {
      icon: FiRefreshCw,
      title: 'Refill Guarantee',
      description: 'Free refill warranty on all services. 30-day money-back guarantee.',
      color: 'from-red-500 to-red-600'
    }
  ];

  return (
    <section id="features" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Why Choose Premium SMM Panel?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We provide the best social media marketing services with unmatched quality, 
            speed, and customer support. Here's what makes us different.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-gray-50 rounded-2xl p-8 hover:shadow-xl transition-all duration-300 border border-gray-200 group"
            >
              <div className={`inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r ${feature.color} rounded-xl mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <SafeIcon icon={feature.icon} className="w-8 h-8 text-white" />
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed">{feature.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;